import React, { Fragment } from 'react';
import { isRequiredMessage } from './constants';

export interface AddressProps {
  prefix: string;
  addressMatchControlElement: React.RefObject<HTMLElement>;
  shouldMatchAddresses: boolean;
  billingAddressFieldName: string;
  shippingAddressFieldName: string;
}

export const Address = (props: AddressProps): JSX.Element => {
  const {
    prefix,
    addressMatchControlElement,
    shouldMatchAddresses,
    billingAddressFieldName,
    shippingAddressFieldName,
  } = props;
  const isBilling = prefix === billingAddressFieldName;
  const shouldSkipRender = isBilling && shouldMatchAddresses;
  return (
    <Fragment>
      <roche-headline
        level={3}
        headline={prefix === shippingAddressFieldName ? 'Versandadresse' : 'Rechnungsadresse'}
      />

      {isBilling && (
        <roche-select
          ref={addressMatchControlElement}
          multi-select
          name={`${prefix}-same-as-shipping`}
          options="[{&quot;label&quot;:&quot;entspricht Versandadresse&quot;,&quot;value&quot;:&quot;true&quot;}]"
        />
      )}

      {!shouldSkipRender && (
        <roche-grid layout="6-6" full-width>
          <roche-input
            slot="left"
            label="Straße"
            placeholder="Straße"
            type="text"
            name={`${prefix}-street`}
            required
            error={isRequiredMessage}
          />

          <roche-input
            slot="right"
            label="Hausnummer"
            placeholder="Hausnummer"
            type="text"
            name={`${prefix}-door`}
            required
            error={isRequiredMessage}
          />

          <roche-input
            slot="left"
            label="Postleitzahl"
            placeholder="Postleitzahl"
            type="text"
            name={`${prefix}-zip-code`}
            required
            error={isRequiredMessage}
          />

          <roche-input
            slot="right"
            label="Stadt"
            placeholder="Stadt"
            type="text"
            name={`${prefix}-city`}
            required
            error={isRequiredMessage}
          />

          <roche-input
            slot="left"
            label="Bundesland"
            placeholder="Bundesland"
            type="text"
            name={`${prefix}-state`}
          />

          <roche-dropdown
            slot="right"
            label="Land"
            name={`${prefix}-country`}
            required
            error={isRequiredMessage}
            options="[{&quot;label&quot;:&quot;Deutschland&quot;,&quot;value&quot;:&quot;DE&quot;},{&quot;label&quot;:&quot;Andere&quot;,&quot;value&quot;:&quot;OTHER&quot;}]"
          />
        </roche-grid>
      )
      }
    </Fragment>
  );
};
